export default "__VITE_ASSET__DKzlUOuM__"